import { forEach } from "lodash";

export default {
  methods: {
    getVendorSiteOfTreatmentName(item) {
      return item.disposal_site?.disposal_site_by_waste_category
        ?.vendor_site_of_treatment?.name_abbreviated;
    },
    getWasteOrServiceName(item) {
      let name = "";
      let wasteOrServiceByWorkOrder = item[0]?.waste_or_service_by_work_order;

      if (wasteOrServiceByWorkOrder) {
        name =
          wasteOrServiceByWorkOrder?.waste?.name ??
          wasteOrServiceByWorkOrder?.service?.name;
        name = name ? name + (item.length > 1 ? " 他" : '') : "";
      }

      return name ?? '';
    },
    getWasteOrServiceNameWithQuantity(item) {
      let name = "";
      name = item
        .map(element => {
          return (
            (element.waste_or_service_by_work_order?.waste?.name ??
            element.waste_or_service_by_work_order?.service?.name) +
            (element.measurement_quantity ? `（${parseInt(element.measurement_quantity)}）` : '')
          );
        })
        .filter(x => !!x)
        .join(" / ");
      return name;
    },
    getVendorName(item) {
      //only take first vendor name if there's another vendor then put a text "他" at last string
      let firstVendorName =
        item[0]?.disposal_site?.disposal_site_by_waste_category
          ?.vendor_site_of_treatment?.name_abbreviated;

      if (firstVendorName) {
        for (const wasteOrServiceBySchedule of item) {
          let isManyTransportDiff =
            wasteOrServiceBySchedule.disposal_site
              ?.disposal_site_by_waste_category?.vendor_site_of_treatment
              ?.name_abbreviated !== firstVendorName;
          if (isManyTransportDiff) {
            firstVendorName += " 他";

            break;
          }
        }
      }

      return firstVendorName ?? '';
    },
    getVendorNameForTooltip(item) {
      //take all vendor name and seperate with " / "
      let name = "";

      name = item
        .map(element => {
          return element?.disposal_site?.disposal_site_by_waste_category
            ?.vendor_site_of_treatment?.name_abbreviated;
        })
        .filter(x => !!x)
        .filter((elem, index, self) => self.indexOf(elem) === index)
        .join(" / ");

      return name;
    },
    getAssignStaffName(item) {
      let name = "";

      name = item
        .map(element => {
          return element?.user_name;
        })
        .filter(x => !!x)
        .join(" / ");

      return name;
    },
    getAssignCarName(item) {
      let name = "";

      name = item
        .map(element => {
          return element?.name + " " + element.number;
        })
        .filter(x => !!x)
        .join(" / ");

      return name;
    },
    getImplements(item) {
      let name = "";

      name = item
        .map(element => {
          return (
            element.implement +
            (element.pivot?.number_of_implements &&
              "x" + element.pivot?.number_of_implements)
          );
        })
        .filter(x => !!x)
        .join(" / ");

      return name;
    },
    getWasteManifestPreparationRole(item) {
      let name = "マニフェスト";
      let manifestPreparationRole = [];

      item.map(element => {
        if (
          element.waste_or_service_by_work_order?.waste &&
          element.waste_or_service_by_work_order?.zz_manifest_preparation_role_id
        ) {
          manifestPreparationRole.push(
            element.waste_or_service_by_work_order.zz_manifest_preparation_roles
              .manifest_preparation_role
          );
        }
      });
      manifestPreparationRole = manifestPreparationRole.filter((elem, index, self) => self.indexOf(elem) === index);

      manifestPreparationRole = manifestPreparationRole.join(" / ");

      return manifestPreparationRole && name + manifestPreparationRole;
    },
    getNumberOfRentalContainers(item) {
    const LABEL = "空容器数量:";
    if (!Array.isArray(item) || item.length === 0) return "";
    //"0", "0.000", "null", "", null, undefined, 0 → 空扱い）
    const isEmptyContainerValue = (raw) => {
      const s = String(raw ?? "").trim().toLowerCase();
      if (s === "" || s === "null") return true;
      const num = Number(s);
      return !Number.isNaN(num) && num === 0;
    };
    //値の整形
    const formatValue = (raw) => String(raw).trim();
    const lines = [];
    item.forEach(it => {
      const list = it?.waste_estimates_by_schedule;
      if (!Array.isArray(list) || list.length === 0) return;
      list.forEach(estimate => {
        const name = String(estimate?.invoice_product_name ?? "").trim();
        const raw  = estimate?.pivot?.number_of_rental_containers;
        if (isEmptyContainerValue(raw)) return; //空扱いは表示しない
        //「商品名：値」の1行を作成 -> 値のみに変更
        lines.push(`${formatValue(raw)}`);
      });
    });
    if (lines.length === 0) return ""; //全て空なら何も表示しない
    //ラベル行 + 明細行（改行区切り）。末尾にも改行を追加
    return `${LABEL}\n${lines.join("\n")}\n`;
    },
    getCommentToUser(item) {
      let label = "作業者備考:\n";
      let commentToUser = [];

      // itemは配列であることを考慮（waste_or_services_by_schedule）
      item.map(element => {
        if (
          element.comment_to_user
        ) {
          commentToUser.push(
            element.comment_to_user
          );
        }
      });
      
      commentToUser = commentToUser.join(" / ");

      // commentToUserが空でなければlabelを付与して返す
      return commentToUser && label + commentToUser;
    }
  }
};
